import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_STATIONARY_ITEM_LOGS, GET_STATIONARY_PURCHASE_DETAILS } from '../graphql/loglist.query';


@Injectable({
  providedIn: 'root',
})
export class LogListService {
  constructor(private apollo: Apollo) {}

  fetchStationaryPurchaseDetails(stationoryId: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: GET_STATIONARY_PURCHASE_DETAILS,
        variables: {
            stationoryId,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.getStationoryPurchaseDetails || []));
  }

  fetchStationaryItemLogs(stationoryId: any, startDate?: string, endDate?: string): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: GET_STATIONARY_ITEM_LOGS,
        variables: {
          stationoryId,
          startDate: startDate || "",
          endDate: endDate || "",    
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.getStationoryItemsLogs || []));
}


}
